import type { CoursesLogInvalidLessonRouteDto } from '@sportspredict/shared';
import type { Wire } from '../../types/common.types';
import { coursesApi } from './courses-base.api';
import type {
	LogInvalidLessonRouteInput,
	LogInvalidLessonRouteOutput,
} from '../../types/lesson-deeplink-logging.types';

const TAG = 'courses:lesson-deeplink-logging' as const;
const INVALIDATES = [TAG] as const;

export const lessonDeeplinkLoggingEndpoints = coursesApi.injectEndpoints({
	endpoints: (builder) => ({
		logInvalidLessonRoute: builder.mutation<
			LogInvalidLessonRouteOutput,
			LogInvalidLessonRouteInput
		>({
			query: (body) => ({
				url: 'courses/client-logs/invalid-lesson-route',
				method: 'POST',
				body: body satisfies Wire<CoursesLogInvalidLessonRouteDto>,
			}),
			invalidatesTags: [...INVALIDATES],
		}),
	}),
});

export const { useLogInvalidLessonRouteMutation } = lessonDeeplinkLoggingEndpoints;
